import gql from 'graphql-tag'

export const GET_EMPLOYEES_PAGINATED = gql`
  query EmployeesPaginated($filter: GetEmployeesWithPaginationInput) {
    employeesPaginated(filter: $filter) {
      employeesPaginated {
        data {
          fullname
          groups {
            name
            id
          }
          userId
          email
          address
          photograph
          identification {
            methods {
              faceRecognition
              rfid
            }
            vehicles {
              licensePlate
              methodStatuses {
                faceRecognition
                rfid
              }
              vehicleId
            }
          }
        }
        pagination {
          page
          show
          total
        }
      }
      errorCode
      errorName
      isSuccessful
      message
      status
    }
  }
`

export const GET_VEHICLES_BY_FEATURE_SUPPORT = gql`
  query VehiclesByFeatureSupport($filter: VehiclesByFeatureSupportFilter!) {
    vehiclesByFeatureSupport(filter: $filter) {
      status
      message
      isSuccessful
      errorName
      errorCode
      vehiclesByFeatureSupport {
        data {
          id
          identificationSupport {
            rfid
            face
          }
          identification {
            rfid {
              status
              data
            }
            fullname
            face {
              data
              status
            }
            driverId
          }
          vehicle2Vgroup {
            vgroup {
              name
            }
          }
          vehicleType {
            type
            model
            manufacturer
            category
          }
          licensePlate
        }
        pagination {
          total
          show
          page
        }
      }
    }
  }
`


export const RETRY_IDENTIFICATION = gql`
  mutation RetryIdentification($input: RetryIdentificationInput!) {
  retryIdentification(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    retryIdentification {
      driverId
      face
      rfid
    }
  }
}
`

export const IMPORT_IDENTIFICATION = gql`
  mutation ImportIdentification($input: ImportFileInput!) {
  importIdentification(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    importIdentification {
      totalData
      totalSuccess
      totalFailed
      originalFile
      successFile
      errorFile
    }
  }
}
`

export const IMPORT_IDENTIFICATION_TEMPLATE = gql`
  query ImportIdentificationTemplate {
  importIdentificationTemplate {
    isSuccessful
    errorCode
    errorName
    message
    status
    importIdentificationTemplate {
      base64
    }
  }
}
`

export const IMPORT_HISTORY = gql`
  query ImportHistory($filter: ImportHistoriesFilter) {
    importHistory(filter: $filter) {
      isSuccessful
      message
      importHistory {
        filename
        importOn
        model
        totalFailed
        totalSuccess
        users {
          fullname
        }
      }
    }
  }
  `
export const RETRY_INDENTIFICATION = gql`
  mutation RetryIdentification($input: RetryIdentificationInput!) {
    retryIdentification(input: $input) {
      status
      message
      isSuccessful
      errorName
      errorCode
    }
  }
`
